<template>
<svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
      d="M0.75 2.75H2V13.25H0.75V2.75ZM7.125 2.75H6.125C6.05625 2.75 6 2.80625 6 2.875V13.125C6 13.1938 6.05625 13.25 6.125 13.25H7.125C7.19375 13.25 7.25 13.1938 7.25 13.125V2.875C7.25 2.80625 7.19375 2.75 7.125 2.75Z"
      fill="#B5C6D8"/>
</svg>
</template>
